import React from 'react';
import { Person } from '@enview/interface/types/Person';
import { OrganizationUser } from '@enview/interface/types/OrganizationUser';
import { UserAction } from '@enview/interface/types/actions/UserAction';
import { UserActivity } from '../Shared/ActivityFeed/Activity';
import ActivityFeed from '../Shared/ActivityFeed/ActivityFeed';
import { Filter, FILTER_OPTIONS } from '../Shared/ActivityFeed/ActivityFeedHelper';

type PersonActivityFeedProps = {
  person: Person;
  userActions: UserAction[];
  orgUser?: OrganizationUser;
};

const PersonActivityFeed = (props: PersonActivityFeedProps): JSX.Element => {
  const { orgUser, userActions, person } = props;
  const filterOptions = FILTER_OPTIONS.filter(
    (option) => option.value !== Filter.BILL_ACTIONS,
  );
  const activities = orgUser
    ? UserActivity.transformUserActions(userActions, orgUser)
    : [];

  return (
    <ActivityFeed
      activities={activities}
      filterOptions={filterOptions}
      person={person}
    />
  );
};

export default PersonActivityFeed;
